var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"LogoHero",attrs:{"alt":`${_vm.heroIcon.description}`,"src":require(`@/assets/${_vm.heroIcon.icon}`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }